'use strict';

const _ = require('lodash');

const IngestorService = function ($state, IdentityService, OrganizationStore, UploaderStore) {
  let service
  let changeStateCbk
  let showAppCbk
  let hideAppCbk
  let showTopbarWidgetCbk
  let hideTopbarWidgetCbk

  let shouldShowOnInit = false

  const stopSpinner = () => {
    var loader = document.getElementById('ingestor-loader-container')
    if (loader) {
      loader.className += ' -app-ready'
      loader.style.display = 'none'
    }
  }

  const startSpinner = () => {
    var loader = document.getElementById('ingestor-loader-container')
    if (loader) {
      loader.className = ''
      loader.style.display = 'fixed'
    }
  }

  const init = () => {
    const initData = {
      ingestApiUri: { url: IdentityService.getIngestApiUri(), basePath: '' },
      coreApiUri: { url: IdentityService.getApiUri(), basePath: '' },
      authApi: { url: IdentityService.getAuthApiUri(), basePath: '' },
      geopingApiUri: { url: IdentityService.getGeopingApiUri(), basePath: '' },
      skyApiUri: { url: IdentityService.getSkyApiUri(), basePath: '' }
    }

    document.ingestorInitData = initData
  };

  const setService = (initializedService) => {
    document.ingestorService = initializedService
    service = initializedService
  }

  const start = () => {
    var container = document.getElementById('ingestor-iframe-container')
    container.style.display = 'block'

    if(shouldShowOnInit) {
      showAppCbk && showAppCbk()
      stopSpinner()
    } else {
      hideAppCbk && hideAppCbk()
    }
  }

  _.extend(this, {
    attachIngestor: () => {
      // IFrame Preload
      try {
        const src = document.getElementById('ingestor-frame').src;
        if (!src || (src && src.split('/').pop() !== 'ingestor')) {
          document.getElementById('ingestor-frame').src = '/ingestor'
        }
      }
      catch (e) {}
    },
    stopSpinner: stopSpinner,
    startSpinner: startSpinner,
    init: init,
    start: start,
    setService: setService,
    getSites: () => {
      try {
        const projects = OrganizationStore.get('projects')
        if(!projects.length) {
          return null
        }
        const sites = projects.map((project) => {
          return project.sites
        })
        const mySites = [].concat.apply([], sites);
        const enrichedUserSites = OrganizationStore.get('user').userSites.map((site) => {
          const richSites = mySites.find((st) => { return st.id === site.id })
          return Object.assign(site, richSites)
        })
        return enrichedUserSites
      } catch (e) {
        return null
      }
    },
    getPlan: () => {
      try {
        return OrganizationStore.get('plan')
      } catch (e) {
        return null
      }
    },
    storeSiteName: (name) => {
      UploaderStore.setSiteName(name)
    },
    storeDate: (date) => {
      UploaderStore.setFlightDate(date)
    },
    storeState: (state) => {
      UploaderStore.setState(state)
    },
    sendStateChange: (state) => {
      changeStateCbk && changeStateCbk(state)
    },
    registerChangeState: (callback) => {
      changeStateCbk = callback
    },
    sendShowApp: () => {
      showAppCbk && showAppCbk()
    },
    registerShowApp: function(callback) {
      showAppCbk = callback
    },
    sendHideApp: () => {
      hideAppCbk && hideAppCbk()
    },
    registerHideApp: function(callback) {
      hideAppCbk = callback
    },
    sendShowTopbarWidget: () => {
      showTopbarWidgetCbk && showTopbarWidgetCbk()
    },
    registerShowTopbarWidget: function(callback) {
      showTopbarWidgetCbk = callback
    },
    sendHideTopbarWidget: () => {
      hideTopbarWidgetCbk && hideTopbarWidgetCbk()
    },
    registerHideTopbarWidget: function(callback) {
      hideTopbarWidgetCbk = callback
    },
    goToUploader: function() {
      $state.go('uploader')
    },
    setShowOnInit: (showOnInit) => {
      shouldShowOnInit = showOnInit
    }
  });
};

IngestorService.$inject = ['$state', 'IdentityService', 'OrganizationStore', 'UploaderStore']

module.exports = IngestorService;



// WEBPACK FOOTER //
// ./src/common/ingestor/IngestorService.js